import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedDate, FormattedRelative } from 'react-intl';
import cx from 'classnames';
import Loader from '../Loader';
import Icon from '../Icon';
import s from './HistoryDocument.css';
import documentTypes from '../../constants/documentTypes';
import {
  setDeviceDocumentInfo,
  downloadDeviceDocument,
  removeDeviceDocument,
} from '../../actions/documents';

const DAY = 86400000;

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class HistoryDocument extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      now: new Date()
    };
  }
  componentWillReceiveProps(newProps) {
    console.log('new prop-types')
    this.setState({
      now: new Date(),
    });
  }
  onSavePDF = (serial, documentName) => {
    this.props.downloadDeviceDocument(
      serial,
      documentName,
      {},
    );
  };

  setDeviceDocumentInfo = (serial, deviceName, documentName, documentType, deviceType) => {
    this.props.setDeviceDocumentInfo(
      serial,
      deviceName,
      documentName,
      documentType,
      deviceType,
    );
  };

  renderDownloading = () => {
    return (
      <div className={s.iconWrapper}>
        <Loader />
      </div>
    );
  };

  renderDownload = (documentName, iconSize) => {
    // const bucketName = `test-attachments-history`;
    const bucketName = `attachments-history`;
    // const bucketName = process.env.AWS_BUCKET_NAME || `test-attachments-history`;
    const downloadLink = `https://${bucketName}.s3.eu-west-3.amazonaws.com/device_history/${documentName}`;
    // const downloadLink = `/uploads/${documentName}`
    return (
      <div className={s.iconWrapper}>
        <a href={downloadLink} target="_blank">
          <Icon iconName={'pobierz'} size={iconSize} />
        </a>
      </div>
    );
  };

  renderRemove = (serial, documentName, iconSize) => {
    return (
      <div
        className={s.iconWrapper}
        onClick={() => {
          this.props.removeDeviceDocument(serial, documentName);
          // this.props.getDeviceDocumentsList(serial);
        }}>
        <Icon iconName={'kosz'} size={iconSize} />
      </div>
    );
  };

  renderDocumentName = (documentName, documentSize, greenOne) => {
    const documentStyle = greenOne 
      ? cx(s.green, s.u_flexGrow1) 
      : cx(s.u_flexGrow1);
    return (
      <div className={documentStyle}>
        {documentName} {documentSize} {greenOne}
      </div>
    );
  };

  render() {
    const { serial, deviceType, newFilesDownloaded, deviceName } = this.props;
    const documentName = this.props.document.get('name');
    const documentSize = this.props.document.get('size');
    const documentType = documentTypes[documentName.split('.')[1]];
    const iconSize = 20;

    // const date = new Date(this.props.document.get('timestamp') * 1000);
    const date = new Date(0);
    date.setUTCSeconds(this.props.document.get('timestamp'));
    const greenOne =
      newFilesDownloaded && 
      newFilesDownloaded.includes(this.props.document.get('timestamp'));
    const downloadingDocument = this.props.deviceDocumentsPaging.get('downloadingDocument');
    const formattedTime =
      this.state.now - date < DAY ? (
      <FormattedRelative value={date} initialNow={new Date()} /> ) : (
      <FormattedDate value={date}/> );

    if (+documentType === 3) {
      return (
        <div className={s.listBordered_item}>
          {this.renderDocumentName(documentName, documentSize, greenOne)}
          <div className={s.iconsWrapper}>
             {formattedTime} {}
              {!downloadingDocument ? (
                <div
                  className={s.iconWrapper}
                  onClick={() => {
                    this.onSavePDF(serial, documentName)
                  }}
                >
                  <Icon iconName={'lupka'} size={iconSize} />
                </div>
              ) :  this.renderDownloading() }
            {this.renderDownload(documentName, iconSize)}
            {this.renderRemove(serial, documentName, iconSize)}
          </div>
        </div>
      )
    } 

    return (
      <div className={s.listBordered_item}>
        {this.renderDocumentName(documentName, documentSize, greenOne)}
        <div className={s.iconsWrapper}>
           {formattedTime} {}
          <div
            className={s.iconWrapper}
            onClick={() => {
              this.setDeviceDocumentInfo(
                serial,
                deviceName,
                documentName,
                documentType,
                deviceType,
              );
            }}
          >
            <Icon iconName={'lupka'} size={iconSize} />
          </div>
          {this.renderDownload(documentName, iconSize)}
          {this.renderRemove(serial, documentName, iconSize)}
        </div>
      </div>
    );
  }
}

HistoryDocument.propTypes = {
  deviceType: PropTypes.string.isRequired,
  serial: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  document: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentsPaging: PropTypes.object.isRequired,
  setDeviceDocumentInfo: PropTypes.func.isRequired,
  downloadDeviceDocument: PropTypes.func.isRequired,
  removeDeviceDocument: PropTypes.func.isRequired,
  newFilesDownloaded: PropTypes.arrayOf(PropTypes.number).isRequired,
  getDeviceDocumentsList: PropTypes.func.isRequired,
};

const mapDispatch = dispatch => {
  return {
    setDeviceDocumentInfo: (serial, deviceName, documentName, documentType, deviceType) =>
      dispatch(
        setDeviceDocumentInfo(serial, deviceName, documentName, documentType, deviceType)
      ),
    removeDeviceDocument: (deviceid, documentid) => dispatch(removeDeviceDocument(deviceid, documentid)),
    downloadDeviceDocument: (serial, documentId, filterData, events) => 
      dispatch(downloadDeviceDocument(serial, documentId, filterData, events)),
  };
};

const mapState = state => ({
  deviceDocumentsPaging: state.deviceDocumentsPaging,
});

export default compose(withStyles(s), connect(mapState, mapDispatch))(
  HistoryDocument
);



// WEBPACK FOOTER //
// ./src/components/HistoryDocuments/HistoryDocument.js